
<scroll-area class="work-area workarea" ref="workArea">
  <div class="container">
    <div class="em-block">
      <div class="em-child">
        <div class="row">
          <div class="col">
            <h2>Experimental Features</h2>
            <hr>
          </div>
        </div>
        <feature id="object_model_diagrams">
          <view-experimental-object-model-diagrams></view-experimental-object-model-diagrams>
        </feature>
        <feature id="create_associated_views">
          <view-experimental-create-associated></view-experimental-create-associated>
        </feature>
      </div>
    </div>
  </div>
</scroll-area>
